module.exports = __webpack_public_path__ + "static/img/Boss_31085.9860ebad.png";